export const TIN_REQUIRED_RULES = ['ES-1001', 'ES-1002', 'N-10001', 'N-10002', 'N-10003', 'N-10004'];
import moment from 'moment';

// Recursive Javascript program to check if
// a string is subsequence of another string

// Returns true if str1[] is a
// subsequence of str2[] m is
// length of str1 and n is length
// of str2
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function format_datetime(value) {
    if (value) {
        return moment(String(value)).format('DD MMM, YYYY hh:mm a')
    }
}

export function format_date_ddmmmyyyy(value) {
    if (value) {
        return moment(String(value)).format('DD MMM, YYYY')
    }
}

export function format_date_yyyymmdd(value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
    }
}

export function format_date_mmddyyyy(value) {
    if (value) {
        return moment(String(value)).format('MMMM DD, YYYY')
    }
}

export function isStringNull(string) {
    if (string == null || string == "") {
        return true;
    }
    return false;
}

export function isSubSequence(str1, str2, m, n) {

    // Base Cases
    if (m == 0) return true;
    if (n == 0) return false;

    // If last characters of two strings
    // are matching
    if (str1[m - 1] == str2[n - 1]) return isSubSequence(str1, str2, m - 1, n - 1);

    // If last characters are not matching
    return isSubSequence(str1, str2, m, n - 1);
}

export function numberOnly(evt) {
    const key = evt.keyCode
    const char = String.fromCharCode((96 <= key && key <= 105) ? key - 48 : key)
    if (![8, 9, 10, 13, 46].includes(evt.keyCode) && !/[0-9]/.test(char)) {
        evt.preventDefault()
    }
}

export function getYesNo(v) {
    if (v) {
        v = v.toUpperCase()
        if (['Y', 'YES', 1, '1'].includes(v)) return 'YES';
        if (['N', 'NO', 'N/A', 0, '0', ''].includes(v)) return 'NO';
    }
    return v;
}

export function printPage(selector = '.printable') {
    let html = '';
    let elements = document.querySelectorAll(selector);
    for (let element of elements) {
        html += element.outerHTML + '<br/>';
    }

    html += `
<p style="font-size: 12pt">
    I have read the above information carefully. I confirm that the information above is correct.
    <br><br><br><br><br>
    <span style="text-align: center; display: inline-block">
        -------------------------------------------------------------------------<br>
        Signature
    </span>
</p>
    `;

    let win = window.open("", "_blank", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes");
    win.document.body.innerHTML = html;
    //win.document.head.innerHTML = document.head.innerHTML;
    win.document.head.innerHTML += `
<style>
.text-center {
    text-align: center !important;
}
.text-left {
    text-align: left !important;
}
.text-right {
    text-align: right !important;
}
td, th, :root {
    font-size: 8pt;
}
table {
    width: 100%;
}
table, table th, table td {
    border: 1pt solid black;
    border-collapse: collapse;
    padding: 2pt;
}

input[type=checkbox], button {
    display: none;
}

.amount-values td:not(:first-child) {
    text-align: right;
    width: min-content;
}

th, td {
    vertical-align: middle;
}

@page {
    size: A4 landscape;
}
</style>`;
    win.document.title = 'Confirmation Form';
    win.print();
    win.close();
}

export function extractError(e) {
    let err = 'SOMETHING WENT WRONG!';
    if (e.response) {
        if (e.response.data) {
            err = e.response.data.error || e.response.data.message;
        } else {
            err = e.response.statusText || e.response.statusMessage || e.message;
        }
    }
    return err;
}
